import { getDietQualityColor } from '../../../lib/themes/generalTheme';

export const getChipColor = (name) => {
  switch (name.toLowerCase()) {
    case 'carbohydrates':
      return getDietQualityColor(5);
    case 'total fat':
      return getDietQualityColor(7);
    case 'protein':
      return getDietQualityColor(9);
    default:
      return 'transparent';
  }
};

export const getChipStyles = (name) => ({
  backgroundColor: getChipColor(name),
  '& .MuiChip-label': {
    overflow: 'visible',
    textOverflow: 'unset',
    whiteSpace: 'normal',
  },
});

export const getMacronutrientData = (data) => {
  if (!data || !Array.isArray(data)) return null;

  const currentCarbs = Number(data[1]?.current) || 0;
  const currentFat = Number(data[2]?.current) || 0;
  const currentProtein = Number(data[3]?.current) || 0;

  const totalCalories = currentCarbs * 4 + currentFat * 9 + currentProtein * 4;

  const currentPercentages = {
    carbohydrates: totalCalories > 0 ? Math.round(((currentCarbs * 4) / totalCalories) * 100) : 0,
    totalFat: totalCalories > 0 ? Math.round(((currentFat * 9) / totalCalories) * 100) : 0,
    protein: totalCalories > 0 ? Math.round(((currentProtein * 4) / totalCalories) * 100) : 0,
  };

  return {
    calories: {
      name: data[0]?.name || 'Estimated Calorie Intake',
      current: data[0]?.current || '0',
      goal: data[0]?.goal || '0',
      unit: data[0]?.unit || 'kcal',
    },
    macronutrients: [
      {
        name: data[1]?.name || 'Carbohydrates',
        current: data[1]?.current || '0',
        currentPercentage: currentPercentages.carbohydrates || null,
        goal: data[1]?.goal || '0',
        goalPercentage: totalCalories > 0 ? Math.round(((Number(data[1]?.goal || 0) * 4) / totalCalories) * 100) : null,
        unit: data[1]?.unit || 'g',
        allCurrentPercentages: currentPercentages,
      },
      {
        name: data[2]?.name || 'Total Fat',
        current: data[2]?.current || '0',
        currentPercentage: currentPercentages.totalFat || null,
        goal: data[2]?.goal || '0',
        goalPercentage: totalCalories > 0 ? Math.round(((Number(data[2]?.goal || 0) * 9) / totalCalories) * 100) : null,
        unit: data[2]?.unit || 'g',
        allCurrentPercentages: currentPercentages,
      },
      {
        name: data[3]?.name || 'Protein',
        current: data[3]?.current || '0',
        currentPercentage: currentPercentages.protein || null,
        goal: data[3]?.goal || '0',
        goalPercentage: totalCalories > 0 ? Math.round(((Number(data[3]?.goal || 0) * 4) / totalCalories) * 100) : null,
        unit: data[3]?.unit || 'g',
        allCurrentPercentages: currentPercentages,
      },
    ],
  };
};
